import script from "./RecollectionRequest.vue?vue&type=script&setup=true&lang=js"
export * from "./RecollectionRequest.vue?vue&type=script&setup=true&lang=js"

import "./RecollectionRequest.vue?vue&type=style&index=0&id=1bf4c65c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bf4c65c"]])

export default __exports__